import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { verifyOTP } from '../../reducers/authReducer'

import { Form, Input, Button, message } from 'antd'
import { MailOutlined } from '@ant-design/icons'

import { PageContainer, FormContainer, FormWrapper, FormTitle } from './style'

const VerifyOTP = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading } = useSelector((state) => state.auth)
  const [countdown, setCountdown] = useState(300)

  const stored = JSON.parse(window.localStorage.getItem('spanidea-user')) || {}

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          message.error('OTP expired. Please request a new one.')
          navigate('/login')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  const onFinish = (values) => {
    dispatch(verifyOTP({ email: stored.email, otp: values.otp }))
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <Form name="verifyOTP" onFinish={onFinish} scrollToFirstError>
            <FormTitle>Verify OTP</FormTitle>
            <br />
            <Form.Item
              name="otp"
              rules={[
                {
                  required: true,
                  message: 'Please enter the OTP'
                },
                {
                  pattern: /^\d{6}$/,
                  message: 'OTP must be 6 digits'
                }
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="Enter 6-digit OTP"
                maxLength={6}
                disabled={loading}
              />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit" loading={loading}>
                Verify OTP
              </Button>
            </Form.Item>
            <span
              style={{ textAlign: 'right', color: '#1890ff', display: 'block' }}
            >
              Time remaining: {formatTime(countdown)}
            </span>
          </Form>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}

export default VerifyOTP
